import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import React, { useState } from 'react';

import TripMap from '../../maps/TripMap';
import GolfTripMobileLine from './GolfTripMobileLine';
import GolfTripTableRow from './GolfTripTableRow';

function GolfTripCard({
  golfCourses,
  selectedCountrySearch,
  countryRankPrefix,
  locationType,
}) {
  const [showMap, setShowMap] = useState(false);
  //console.log("locationType", locationType)

  const getHighestGreenFee = (greenFees) => {
    const propertiesToCheck = [
      'high_weekday',
      'high_weekday_twighlight',
      'high_weekend',
      'high_weekend_twighlight',
      'low_weekday',
      'low_weekday_twighlight',
      'low_weekend',
      'low_weekend_twighlight',
    ];

    const feeValues = propertiesToCheck
      .map((prop) => greenFees[prop])
      .filter((value) => value !== null); // Filter out null values

    if (feeValues.length === 0 || Math.max(...feeValues) === 0) return -1;

    return Math.max(...feeValues);
  };

  const totalGreenFee = golfCourses
    .map((course) => getHighestGreenFee(course.green_fees))
    .reduce((acc, fee) => (fee === -1 ? acc : acc + fee), 0);

  const hasIncompleteData = golfCourses.some(
    (course) => getHighestGreenFee(course.green_fees) === -1,
  );

  return (
    <div className="mx-auto bg-white bg-opacity-80 shadow-md rounded-md p-4 w-full max-w-5xl mb-4">
      <h2 className="text-xl font-semibold mb-4">Golf Trip Itinerary:</h2>
      <button
        className="mx-auto flex justify-center items-center h-5 w-full sm:h-8 text-center rounded bg-indigo-600 p-4 text-white hover:bg-indigo-700 border border-white my-4"
        onClick={() => setShowMap(!showMap)}
      >
        {showMap ? (
          <>
            <FontAwesomeIcon icon={solid('list')} className="mr-2 text-white" />
            <span className="block">List View</span>
          </>
        ) : (
          <>
            <FontAwesomeIcon
              icon={solid('map-location-dot')}
              className="mr-2 text-white"
            />
            <span className="block">Map View</span>
          </>
        )}
      </button>

      {showMap ? (
        <div className="h-[350px] md:h-[400px]">
          <TripMap courses={golfCourses} />
        </div>
      ) : (
        <>
          {/* Table for Larger Screens */}
          <div className="hidden md:block h-full">
            <table className="min-w-full border-collapse text-sm sm:text-base">
              <thead>
                <tr className="text-indigo-900 font-bold text-sm xl:text-base">
                  <td>Day</td>
                  <td>Course</td>
                  {locationType !== 'County' && locationType !== 'Country' && (
                    <td>Distance</td>
                  )}
                  <td>County</td>
                  <td>Country Rank</td>
                  <td>County Rank</td>
                  <td>Style</td>
                  <td>Green Fee Range</td>
                </tr>
              </thead>
              <tbody className="text-left">
                {golfCourses.map((course, index) => (
                  <GolfTripTableRow
                    key={index}
                    day={index + 1}
                    course={course}
                    selectedCountrySearch={selectedCountrySearch}
                    countryRankPrefix={countryRankPrefix}
                  />
                ))}
              </tbody>
            </table>
            <div className="w-full text-xl text-center mt-4 font-bold border border-gray-400 rounded-md">
              {totalGreenFee === 0
                ? "Sorry, we don't have enough green fee data to estimate the cost of the golf."
                : hasIncompleteData
                  ? `We don't have all the data yet, but in high season the golf will cost over £${totalGreenFee}`
                  : `Green Fees in high season will cost up to £${totalGreenFee}`}
            </div>
          </div>

          {/* Cards for Mobile */}
          <div className="md:hidden">
            {golfCourses.map((course, index) => (
              <GolfTripMobileLine
                key={index}
                day={index + 1}
                course={course}
                selectedCountrySearch={selectedCountrySearch}
                countryRankPrefix={countryRankPrefix}
              />
            ))}
          </div>
          <div className="md:hidden w-full text-xl text-center mt-4 font-bold border border-gray-400 rounded-md">
            {totalGreenFee === 0
              ? "Sorry, we don't have enough green fee data to estimate the cost of the golf."
              : hasIncompleteData
                ? `We don't have all the data yet, but in high season the golf will cost over £${totalGreenFee}`
                : `Green Fees in high season will cost up to £${totalGreenFee}`}
          </div>
        </>
      )}
    </div>
  );
}

export default GolfTripCard;
